<div class="create-zone-container">
  <div class="create-zone-header" fxLayout="row" style="align-items: center;">
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
    <span>Close</span>
  </div>
  <div class="create-zone-body" fxLayout="column">
    <h4>{{pageTitle}}</h4>
    <div class="create-zone-form" [formGroup]="zoneForm" fxLayout="column">
      <!-- Zone Name -->
      <mat-form-field class="zone-name-form" fxFlex appearance="outline">
        <mat-label>Zone Name</mat-label>
        <input matInput formControlName="zoneName" />
        <mat-error *ngIf="zoneName.invalid && (zoneName.dirty || zoneName.touched)">
          <div *ngIf="zoneName.errors?.required">Zone Name is required.</div>
          <div *ngIf="zoneName.errors?.pattern">Zone Name cannot contain only whitespace.</div>
        </mat-error>
      </mat-form-field>
      <!-- Select Category -->
      <ng-container *ngIf="data$ | filterDataAsyncLoading | async as filterData; else filterSkeleton">
        <app-dropdown
          [class]="'categories-select'"
          [uniqueFormName]="'Category'"
          [dataForDropdown]="filterData"
          [z_formGroup]="zoneForm"
          [selectOptionsControlName]="'selectedCategory'"
          [isMultiple]="isMultiple"
          [enableAllOptions]="enableAllOptions"
          [blueCheckmarks]="blueCheckmarks"
          (pickedFilters)="handleFilterChange($event, 'param')"
        ></app-dropdown>
      </ng-container>

      <div class="create-zone-category" fxLayout="row" fxLayoutAlign="end">Create zone category</div>
    </div>
  </div>
  <div class="create-zone-footer" fxLayout="row" fxLayoutGap="10px">
    <button mat-stroked-button fxFlex (click)="onClose()">Cancel</button>
    <button mat-stroked-button [disabled]="isSaveBtnDisabled" (click)="onSave()" fxFlex>Save zone</button>
  </div>
</div>

<ng-template #filterSkeleton>
  <div class="filters-skeleton-container">
    <ngx-skeleton-loader count="1"
    [theme]="{'border-radius': '0.25rem', 'height': '2.5rem', 'margin-bottom': '0', 'width': '100%'}"></ngx-skeleton-loader>
  </div>
</ng-template>
